import { Action } from '@/_core/fluxstore/types';
import { snackbar } from '@/_core/app-components/use';
import { CommandResult } from '@/_core/cqrs/types/commands';
import { createEmptyTrashBinCommand } from '../../../api/commands/factory/createEmptyTrashBinCommand';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { sendTrashCommand } from './sendTrashCommand';

const { registerMiddleware, registerReducer } = useStorymapStore();

export class EmptyTrashBin extends Action<StorymapState> {
    public static ACTION_TYPE = 'EmptyTrashBin';

    public constructor() {
        super(EmptyTrashBin.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState): Promise<boolean> => {
    if (!state.canAdminister || state.trashState.isLoading || state.trashState.isEmptying) {
        return true;
    }

    const token = state.trashState.emptyOperationToken + 1;
    state.trashState.emptyOperationToken = token;
    state.trashState.isEmptying = true;

    try {
        const result = await sendTrashCommand<CommandResult>(await createEmptyTrashBinCommand());

        if (result?.IsSuccess) {
            if (state.trashState.isDialogOpen && state.trashState.emptyOperationToken === token) {
                state.trashState.rows = [];
                state.trashState.selectedRowId = null;
            }
            snackbar.showSuccess('Trash emptied.');
            return true;
        }

        snackbar.showError(result?.Message || 'Empty Trash failed. Please try again.');
        return true;
    } finally {
        if (state.trashState.isDialogOpen && state.trashState.emptyOperationToken === token) {
            state.trashState.isEmptying = false;
        }
    }
};

const reducer = (): void => {
    // State is updated in middleware because command success/failure preserves or clears rows.
};

//@ts-ignore
registerMiddleware(EmptyTrashBin.ACTION_TYPE, middleware);
//@ts-ignore
registerReducer(EmptyTrashBin.ACTION_TYPE, reducer);
